import { render, staticRenderFns } from "./NgrgTable.vue?vue&type=template&id=9fe86e1a&"
import script from "./NgrgTable.js?vue&type=script&lang=js&"
export * from "./NgrgTable.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports